export const accommodationMealplans = {
  MEALPLANS_DESCRIPTION_TOGGLED: 'accommodationMealplans.description'
}
